import React, { Fragment } from 'react'

const About = () => {
  return (
    <Fragment>
      <h1>About this App</h1>
      <p>App to Search Breaking Bad Characters Info</p>
      <p>Version : 0.0.0</p>
    </Fragment>
  )
}

export default About
